import TourTicketList from './TourTicketList';

export default TourTicketList;
